module.exports = __webpack_public_path__ + "static/media/kleros.3c06f69c.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/kleros.png
// module id = 1149
// module chunks = 0